import React, { useState, useEffect } from "react";
import styled, { css, keyframes } from "styled-components";
import { Box, Typography } from "@bca/ui-library";
import { position, PositionProps } from "styled-system";

import HandPointerSVG from "./Icons/HandPointerSVG";

interface DoubleTapToZoomProps extends PositionProps {
  top?: number | string;
  left?: number | string;
}

interface OverlayContainerProps extends PositionProps {
  animationDurationFade: number;
}

const fade = keyframes`
  0% {
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

const animationFade = (props) =>
  css`
    ${fade} ${props.animationDurationFade}s
  `;

const OverlayContainer = styled(Box)<OverlayContainerProps>`
  ${position};
  opacity: 0;
  animation: ${animationFade};
`;

const IconAndTextContainer = styled(Box)<PositionProps>`
  ${position};
  transform: translate(-50%, -50%);
`;

const DoubleTapToZoom: React.FunctionComponent<DoubleTapToZoomProps> = ({
  top = "50%",
  left = "50%",
}) => {
  const [showOverlay, setShowOverlay] = useState(true);
  useEffect(() => {
    const timeout = setTimeout(() => setShowOverlay(false), 5000);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      {showOverlay && (
        <OverlayContainer
          width="100%"
          height="100%"
          animationDurationFade={5}
          position="fixed"
          zIndex={1}
        >
          <Box
            width="100%"
            height="100%"
            opacity={0.6}
            backgroundColor="black"
          />
          <IconAndTextContainer
            position="absolute"
            top={top}
            left={left}
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
          >
            <HandPointerSVG width={21} height={24}></HandPointerSVG>
            <Typography
              variant="h6"
              m={0}
              mt={2}
              color="primary-white"
              font-weight={1}
            >
              Double tap to zoom
            </Typography>
          </IconAndTextContainer>
        </OverlayContainer>
      )}
    </>
  );
};

export default DoubleTapToZoom;
